import ScrollingText from './ScrollingText';

export default ScrollingText;
